export default __webpack_public_path__ + "static/media/wapp.cb35f78d.png";